module.exports = __webpack_public_path__ + "img/racecourse-greyville-poly.dfb7a92a.svg";